import { CSSObject } from "styled-components";

export const ACTIVE_SCROLLBAR_BORDER_WIDTH_VALUE = 8;

export default function cssObjectForActiveScrollbar(
	orientation: "horizontal" | "vertical"
): CSSObject {
	return {
		[`&.ScrollableContainer--active-${
			orientation === "horizontal" ? "h" : "v"
		}`]: {
			cursor: "grab",
			[`&::-webkit-scrollbar-track:${orientation}:hover`]: {
				border: `${ACTIVE_SCROLLBAR_BORDER_WIDTH_VALUE}px solid transparent`,
			},
			[`&::-webkit-scrollbar-thumb:${orientation}:hover`]: {
				border: `${ACTIVE_SCROLLBAR_BORDER_WIDTH_VALUE}px solid transparent`,
			},
			"&.ScrollableContainer--mouse-down": {
				cursor: "grabbing",
				[`&::-webkit-scrollbar-thumb:${orientation}`]: {
					border: `${
						ACTIVE_SCROLLBAR_BORDER_WIDTH_VALUE - 2
					}px solid transparent`,
				},
			},
		},
	};
}
